import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'

import { AbcListComponent } from '../../common/base-components/abc-list/abc-list.component'
import { InputType } from '../../common/enums/input-type.enum'
import { Filter } from '../../common/interfaces/filter.interface'
import { ResourceDefinition } from '../../common/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../common/services/breadcrumb.service'
import { FlashMessageService } from '../../common/services/flash-message.service'
import { ResourceService } from '../../common/services/resource.service'
import { userAvailabilityDefinition } from './user-availability.definition'

@Component({
  selector: 'app-user-availability',
  templateUrl: './user-availability.component.html',
  styleUrls: ['./user-availability.component.scss']
})
export class UserAvailabilityComponent
  extends AbcListComponent
  implements OnInit
{
  definition: ResourceDefinition = userAvailabilityDefinition

  filters: Filter[] = [
    {
      label: `Date`,
      properties: {
        dateFrom: 'dateFrom',
        dateTo: 'dateTo'
      },
      inputType: InputType.DateRange,
      className: 'is-12-mobile is-12-tablet is-6-widescreen p-x-0-mobile ',
      initialValue: {
        dateFrom: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        dateTo: moment().endOf('isoWeek').format('YYYY-MM-DD')
      },
      showClearDateButton: false
    },
    {
      label: 'Collaborateurs',
      properties: {
        value: 'userIds'
      },
      placeholder: 'Tous',
      selectOptions: () =>
        this.componentResourceService.listSelectOptions('users'),
      inputType: InputType.MultiSelect,
      className: 'is-12-mobile is-6-tablet is-6-widescreen p-x-0-mobile'
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    private componentResourceService: ResourceService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
